

































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ParentInfoJf',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
